export const selectBookOnBehalfAgentName = state => {
  const entities = state.entities;
  const agentId = state.bus.bookingSearchForm.agentId;
  const busAgentAutoCompleteSchema = entities.busAgentAutoCompleteSchema || {};
  const agent = busAgentAutoCompleteSchema[agentId];

  if (!agent) {
    return '';
  }

  return agent.agentUserName;
};
